import { HttpParams } from '@angular/common/http';
import { OnInit, Component, NgZone, Inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
//import { AuthenticateService } from '../services/authenticate.service';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'login',
    templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit,OnDestroy  {
    token: any;
    loading = false;
    //url = environment.hostName;
    //appName = environment.appName;
    userSession: any;
    alertInfo: boolean = false;
   // hostURL = environment.hostName + '/oauth2/authorize/' + this.appName + '?response_type=code&redirect_uri=';
    redirectURL: string = '';
    redirectHost: string = '';
    dashboardURL: any;
    private readonly _destroying$ = new Subject < void > ();
    isIframe = false;
    loginDisplay = false;
    constructor(public router: Router, private zone: NgZone, private route: ActivatedRoute, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private authService: MsalService, private msalBroadcastService: MsalBroadcastService) {
        
        
        // this.route.queryParamMap.subscribe((params) => {
        //     this.token = { ...params };
        //   // debugger
        //     this.redirectHost = window.location.protocol + "//" + window.location.host;
        //     this.redirectURL = this.hostURL + this.redirectHost + '/login&scope=oauth';
        //     if (this.token.params['code']) {
        //         this.getAccessToken();
        //     }
        //     else if (this.token.params['error']) {
        //         this.router.navigate(["/accessdenied"]);
        //     }
        //     else {
        //         window.location.href = this.redirectURL;
        //     }

        // });
    }
    ngOnInit() {
        // this.dashboardURL = '/'; //this.route.snapshot.queryParams['returnUrl'] ||
        // this.isIframe = window !== window.parent && !window.opener;
        // if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
        //     if (this.msalGuardConfig.authRequest) {
        //       this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        //         .subscribe((response: AuthenticationResult) => {
        //           this.authService.instance.setActiveAccount(response.account);
        //         });
        //     } else {
        //       this.authService.loginPopup()
        //         .subscribe((response: AuthenticationResult) => {
        //           this.authService.instance.setActiveAccount(response.account);
        //         });
        //     }
        //   } else {
        //     if (this.msalGuardConfig.authRequest) {
        //       this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
        //     } else {
        //       this.authService.loginRedirect();
        //     }
        //   }
        // /**
        //  * You can subscribe to MSAL events as shown below. For more info,
        //  * visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/events.md
        //  */
        // this.msalBroadcastService.inProgress$.pipe(filter((status: InteractionStatus) => status === InteractionStatus.None), takeUntil(this._destroying$)).subscribe(() => {
        //     this.setLoginDisplay();
        // });
    }
    // setLoginDisplay() {
    //     this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    // }
    // login() {
    //     if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
    //       if (this.msalGuardConfig.authRequest) {
    //         this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
    //           .subscribe((response: AuthenticationResult) => {
    //             this.authService.instance.setActiveAccount(response.account);
    //           });
    //       } else {
    //         this.authService.loginPopup()
    //           .subscribe((response: AuthenticationResult) => {
    //             this.authService.instance.setActiveAccount(response.account);
    //           });
    //       }
    //     } else {
    //       if (this.msalGuardConfig.authRequest) {
    //         this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    //       } else {
    //         this.authService.loginRedirect();
    //       }
    //     }
    //   }
    // logout() {
    //     this.authService.logout();
    // }
    // unsubscribe to events when component is destroyed
    ngOnDestroy(): void {
        // this._destroying$.next(undefined);
        // this._destroying$.complete();
    }
    // getAccessToken() {
    //     this.loading = true;
    //     const body = new HttpParams().set('code', this.token.params['code']).set('grant_type', 'authorization_code').set('redirect_uri', this.redirectHost + '/login');
    //     this.authenticateService.getUserSessionInfo(body).subscribe((res) => {
    //         //console.log(res);
    //         this.loading = false;
    //         if (res['access_token']) {
    //             this.loading = true;
    //             this.userSession = res;
    //             localStorage.setItem('TokenInfo', JSON.stringify(this.userSession));
    //             this.router.navigate(['/home']);
    //         } else {
    //             this.loading = false;
    //             this.alertInfo = true;
    //             localStorage.clear();
    //         }
    //     }, (error) => {
    //        // console.log(error);
    //         this.router.navigate(["/error"]);
    //         this.loading = false;
    //         this.alertInfo = true;
    //         localStorage.clear();
    //     })

    // }
    

}
